import { useState } from 'react';
import { ApiError } from '../api/api-error';
import { useAuth } from '../auth/AuthContext';
import { errorMessageFor } from '../auth/error-message';
import { generateTemporaryPassword, safeGenerateTemporaryPassword } from '../lib/temporary-password';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function CoachForm({
  api,
  coach,
  generatePassword = generateTemporaryPassword,
  onCreated,
  onSaved,
  onCancel,
}) {
  const { handleApiError } = useAuth();
  const [username, setUsername] = useState(coach?.username || '');
  const [email, setEmail] = useState(coach?.email || '');
  const [password, setPassword] = useState(() => (coach ? '' : safeGenerateTemporaryPassword(generatePassword).password));
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit(event) {
    event.preventDefault();
    if (submitting) return;
    const cleanName = username.trim();
    const cleanEmail = email.trim();
    if (!cleanName) { setError('Ingresá un nombre para el profesor.'); return; }
    if (!EMAIL_PATTERN.test(cleanEmail)) { setError('Ingresá un email válido.'); return; }
    if (!coach && (!password || password.length < 8)) { setError('La contraseña temporal debe tener al menos 8 caracteres.'); return; }
    setError('');
    setSubmitting(true);
    try {
      if (coach) {
        const response = await api.updateCoach(coach.id, { username: cleanName, email: cleanEmail });
        onSaved(response);
      } else {
        const response = await api.createCoach({ username: cleanName, email: cleanEmail, temporaryPassword: password });
        onCreated({ ...response, password });
      }
    } catch (caught) {
      const outcome = handleApiError(caught);
      if (!outcome.handled) setError(caught instanceof ApiError && caught.code === 'email_taken'
        ? errorMessageFor(caught) : errorMessageFor(caught));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form className="gym-form gym-card gym-admin-coach-form" onSubmit={submit} noValidate aria-label={coach ? 'Editar profesor' : 'Nuevo profesor'}>
      <h2 className="gym-card__title">{coach ? 'Editar profesor' : 'Nuevo profesor'}</h2>
      {error && <p role="alert" className="gym-form__error">{error}</p>}
      <div className="gym-field">
        <label htmlFor="coach-username" className="gym-field__label">Nombre</label>
        <input id="coach-username" className="gym-input" value={username} disabled={submitting} onChange={e => setUsername(e.target.value)} />
      </div>
      <div className="gym-field">
        <label htmlFor="coach-email" className="gym-field__label">Email</label>
        <input id="coach-email" type="email" className="gym-input" value={email} disabled={submitting} onChange={e => setEmail(e.target.value)} />
      </div>
      {!coach && <div className="gym-field">
        <label htmlFor="coach-password" className="gym-field__label">Contraseña temporal</label>
        <div className="gym-admin-password-row">
          <input id="coach-password" className="gym-input gym-admin-password-row__input" autoComplete="off" value={password} disabled={submitting} onChange={e => setPassword(e.target.value)} />
          <button type="button" className="gym-button gym-button--secondary" disabled={submitting} onClick={() => setPassword(safeGenerateTemporaryPassword(generatePassword).password)}>Regenerar</button>
        </div>
      </div>}
      <div className="gym-admin-form-actions">
        <button type="submit" className="gym-button gym-button--primary" disabled={submitting}>{submitting ? 'Guardando…' : coach ? 'Guardar cambios' : 'Crear profesor'}</button>
        <button type="button" className="gym-button gym-button--secondary" disabled={submitting} onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}
